import {Tooltip} from "./Tooltip";

/**
 * @param {string} children
 * @param {number} [length=42]
 * @param {string} [trimChar='…']
 * @param {'start' | 'end' | 'middle'} [mode='end']
 * @param {'top' | 'bottom' | 'left' | 'right'} tooltipPlacement
 * */
export function TextTrim({ children, length = 42, trimChar = '…' , mode = 'end', tooltipPlacement = 'top'}) {
    if (children == null) return '';
    if (children.length <= length) return children;

    let trimmed;
    if (mode === 'middle') {
        const suffixLength = -1 * ((length - length % 2) / 2 - 1);
        const prefixLength = length - suffixLength;
        trimmed = `${children.slice(0, prefixLength)}${trimChar}${children.slice(suffixLength)}`;
    } else if (mode === 'start') {
        const suffixLength = -1 * (length -1);
        trimmed = `${trimChar}${children.slice(suffixLength)}`;
    } else { // mode 'end'
        const prefixLength = length -1; // -1 to fit the trimChar
        trimmed = `${children.slice(0, prefixLength)}${trimChar}`;
    }

    return (
        <Tooltip placement={tooltipPlacement} text={children}>
            <span>{trimmed}</span>
        </Tooltip>
    );
}
